import type React from "react";
import { useContext, useMemo } from "react";
import { LoadingUI } from "../../components/Loading";
import { AuthContext } from "../../hooks/authProvider/authProvider";
import { isAllowDevelopUse } from "../../utils/authority-utils";
import { HomePage } from "./HomePage";

const HomePageContainer: React.VFC = () => {
  const { currentUser, isLoadingUser, authError } = useContext(AuthContext);

  const allowDevelopUse = useMemo(() => {
    if (currentUser?.organizationId) {
      return isAllowDevelopUse(currentUser.organizationId);
    }
    return false;
  }, [currentUser]);

  if (authError) {
    return <div>{JSON.stringify(authError, null, 2)}</div>;
  }
  if (isLoadingUser || !currentUser) {
    return (
      <div className="flex justify-center mt-52">
        <LoadingUI type="Grid" />
      </div>
    );
  }
  return <HomePage allowDevelopUse={allowDevelopUse} />;
};

export default HomePageContainer;
